import { useCallback, useState } from "react";
import SetState from "../typings/SetState";

const useAlert = (setIsLoading: SetState<boolean>) => {
  const [alert, setAlert] = useState("");
  const [alertMessage, setAlertMessage] = useState("");

  //? useCallback is used to avoid the recreation of the custom hook since setIsLoading is a function and it is recreated every time the component in which resides re-render.
  const showAlert = useCallback(
    (message: string, variant: string) => {
      setAlertMessage(message);
      setAlert(variant);
      setIsLoading(false);
    },
    [setIsLoading]
  );

  const closeAlert = useCallback(() => {
    setAlert("");
    setAlertMessage("");
  }, []);

  return {
    alert,
    alertMessage,
    showAlert,
    closeAlert,
  };
};

export default useAlert;
